module.exports = __webpack_public_path__ + "static/media/thank_img.5793fe0d.jpg";